import API from "../services/apiservices";

export default {
  namespaced: true,
  namespace: "parempStore",

  state: {
    storename: "parempStore",
    paremp: {
      codigo: null,
      api: null,
      data: [],
      error: null
    },
    emptyparemp: {
      codigo: null,
      api: null,
      data: [],
      error: null
    },
  },

  getters: {
    gtxStore: () => ({name: "parempStore", route: "Servicos/Paremp/Get", setter: "setParemp"}),
    gtxParemp: (state) => (state.paremp),
    gtxParemp_data: (state) => (state.paremp.data || []),
    gtxParemp_GetById: (state) => (id) => (state.paremp.data.find(f => f.Codigo == id) || {value: 0, text: ""}),
    gtxParemp_selected: (state, getters) => (state.paremp.data.find(f => f.Codigo == getters.gtxParemp_codigo)),
    gtxParemp_dataoptions: (state) => (state.paremp.data ? state.paremp.data.map(o=>({value: o.Codigo, text: o.Reduzido})).sort((a, b) => a.text.localeCompare(b.text)) : []),
    gtxParemp_codigo: (state) => (state.paremp.codigo || 8),
    gtxParemp_reduzido: (state, getters) => getters.gtxParemp_selected ? getters.gtxParemp_selected.Reduzido : "",
    gtxParemp_error: (state) => (state.paremp.error),
    gtxParempEmpty: (state) => (state.emptyclientes),
  },

  mutations: {
    //setParemp: (state, paremp) => (state.paremp = paremp && paremp.data && paremp.data.length > 0 ? {api: paremp.apiresponse, data: paremp.data, codigo: paremp.data[0].Codigo, error: null} : state.emptyparemp),
    setParemp: (state, paremp) => {
      if (paremp && paremp.apiresponse && paremp.data && paremp.data.length > 0) {
        state.paremp.api = paremp.apiresponse;
        state.paremp.codigo = paremp.codigo;
        state.paremp.data = paremp.data;
        state.paremp.error = null;
      } else { state.paremp = state.emptyparemp }
    },
    setParempcodigo: (state, codigo) => state.paremp.codigo = codigo,
    setParempdata: (state, data) => state.paremp.data = data,
  },

  actions: {
    actParempGet({ commit, getters, dispatch }) {
      
      // tem que definir um getter com os dados da store conforme o exemplo:
      // gtxStore: () => ({name: "parempStore", route: "Servicos/Paremp/Get", setter: "setParemp"}),

      // verifica a última atualização da store ...
      return new Promise((res, rej) => {
        try {
          // console.log(new Date().toTimeString().substring(0, 8), "- Carregando", getters.gtxStore.name);
          API.get("Servicos/Stores/Get", { StoreName: getters.gtxStore.name }, false).then((apidata) => {
            let storeUpdate = new Date('02/12/2022'); // para quando não houver data de atualiação da store gravada
            let localUpdate = new Date('01/12/2022');
            const data = API.prepareData(apidata.data);
            if (data.success) {
              storeUpdate = new Date(data.data[0].Updated);
            }
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc) localUpdate = doc.data.updated;
              if (localUpdate > storeUpdate) {
                commit(getters.gtxStore.setter, doc.data);
                dispatch('actParempCodigoGet');
                res(doc.data);
              } else {
                API.get(getters.gtxStore.route, {}, false).then((apidata) => {
                  const data = API.prepareData(apidata.data);
                  commit(getters.gtxStore.setter, data);
                  API.setLocalDBDocument({ data: data }, getters.gtxStore.name);
                  dispatch('actParempCodigoGet');
                  res(data);
                }).catch((error) => {
                  API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
                    if (doc && doc.data) {
                      commit(getters.gtxStore.setter, doc.data);
                      dispatch('actParempCodigoGet');
                      res(doc.data);
                    } else {
                      const emptyData = { data: [], codigo: 0, error: error.message };
                      res(emptyData);
                    }
                  });
                });
              }
            });
          }).catch((error) => {
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc && doc.data) {
                commit(getters.gtxStore.setter, doc.data);
                dispatch('actParempCodigoGet');
                res(doc.data);
              } else {
                const emptyData = { data: [], codigo: 0, error: error.message };
                res(emptyData);
              }
            });
          });
        } catch (err) { rej(err); }});
    },
    actParempCodigoGet({ dispatch }) {
      // atualiza o codigo
      API.getLocalDBDocument("globalStore").then((doc) => {
        //console.log('actParempCodigoGet', doc);
        if (doc && doc.data && doc.data.codigo_paremp) {
          dispatch('actParempCodigoSet', doc.data.codigo_paremp);
        }
      });
    },
    actParempCodigoSet({ commit }, codigo) {
      //console.log('actParempCodigoSet.codigo', codigo);
      commit("setParempcodigo", codigo);

      API.getLocalDBDocument("globalStore").then((doc) => {
        if (doc && doc.data) {
          doc.data.codigo_paremp = codigo;
          API.setLocalDBDocument({ data: doc.data }, "globalStore");
        } else {
          API.setLocalDBDocument({ data: {codigo_paremp: codigo} }, "globalStore");
        }
      });
    }
  },
};
